export default {
    upload: '/upload',
    bus_staff: '/bus-management/staff',
    bus_vehicles: '/bus-management/vehicles',
    bus_route: '/bus-management/routes',
    bus_deposit: '/bus-management/deposit',
    bus_statistic: '/bus-management/statistic',
    monthly_ticket_report: '/bus-management/subscription-order/invoice',
    bus_export: '/bus-management/export-csv',
    bus_ticket_history: '/bus-management/ticket-history',
    bus_companies: '/bus-management/companies',
    bus_stops: '/bus-management/stops',
    bus_features: '/bus-management/features',
    bus_roles: '/bus-management/roles',
    bus_cards: '/bus-management/cards',
    bus_route_subscription: '/bus-management/route-subscription',
    bus_members: '/bus-management/members',
    bus_subscription_order: '/bus-management/subscription-order',
    bus_subscriptions: '/bus-management/subscriptions',
    bus_reports: '/bus-management/reports',
    bus_statement: '/bus-management/statement',
    export_list: '/bus-management/v2/export',
    export_request: '/bus-management/v2/export/request',
    // Authentication API
    admin_client: '/admin/client',
    login_password: '/api/authenticate/login',
    send_sms_code: '/user/auth/otp/request',
    get_sms_code: '/api/authenticate/request_code',
    user: '/user/user',
    user_v2: '/admin/clients',
    reset_password: '/api/user',
    check_user_info: '/api/user/check_info', // Lấy profile user
    get_province: '/bus-management/routes/public/provinces', // Lấy profile user
    change_password: '/user/user/me/change-password',
    verify_sms_code: '/api/authenticate/verify_code',
    directorate_general: '/bus-management/api/v1/directorate-general/send',
    bus_staff_sync: '/bus-management/staff/sync-employee',
    get_user_erp: '/office/employees',
    get_user_hrm: '/hrm/employees', // Lấy thông tin user từ HRM
    get_ticket_types: '/bus-management/tickets/types',
    trip_statistics_for_no_revenue: '/bus-management/statistic/routes',
    // master-data
    master_data: '/master-data/public',
    qlgtcc: '/bus-management/routes/end-point/qlgtcc',
    nfc_card: '/bus-management/nfc-card',
    nfc_card_user: '/bus-management/user/nfc-card',
    nfc_list_history: '/bus-management/nfc-card/history',
    nfc_list_report: '/bus-management/nfc-card/invoice',
    sold_ticket: '/bus-management/tracking/sold-ticket',
    bus_stop_performance: '/bus-management/bus-stop-performance',
    vehicle_report: '/bus-management/statistic/api/vehicle/report',
    get_list_notify: '/api/notification',
    device_token: '/api/user/device_tokens',
    // get announce file
    get_announce_file: '/bus-management/stops/station/generate',
    download_announce_file: '/bus-management/stops/station/download',
    upload_announce_file: '/bus-management/stops/station/upload',
    // tongda
    get_preview_tongda: '/bus-management/route-trip/tong-da/preview',
    sync_tongda: '/bus-management/route-trip/tong-da/sync',
    get_assignment_history: '/bus-management/assignment-history',
    driver_setting_type: '/bus-management/driver/setting',
    driver_setting: '/bus-management/driver-setting',

    // statement
    collect_sales: '/bus-management/collect-sales',

    // transport order
    transport_orders: '/bus-management/transport-orders',
    shipping_order: '/bus-management/shipping-order',

    update_lost_trip_propose: '/bus-management/route-trip/lost-trip/propose',
    get_list_lost_trip: '/bus-management/route-trip/lost-trip',
    get_list_trip_drive: '/bus-management/route-trip/trip-control',
    get_list_lost_trip_approve: '/bus-management/route-trip/lost-trip/approve',
    route_trip: '/bus-management/route-trip',
    bus_promotion: '/bus-management/bus-advertising',
    all_companies: '/bus-management/all-companies',

    // template transport order
    template_transport_order: '/bus-management/public/so/info',
    business_plan: '/bus-management/business-plan',

    online_transaction_reconciliation: '/bus-management/statistic/online/transaction',
    vn_pay_transaction: '/bus-management/statistic/vn-pay/transaction',
    bus_statistic_orders: '/bus-management/statistic/orders',
    ticket_sync_history: '/bus-management/statistic/ticket-sync-history',
    bus_statistic_staffs: '/bus-management/statistic/staffs',
    bus_statistic_date: '/bus-management/statistic/date',

    ota_ticket_package: '/bus-management/v1/admin/ota/ticket-packages',

    revenue_detail_report: '/bus-management/reports/revenue-detail',
    yield_and_revenue_report: '/bus-management/reports/yield-and-revenue',
    ota_admin: '/bus-management/v1/admin/ota/ticket-qrs',
    golab_transaction: '/bus-management/statistic/golab/transaction',
    staff_employee: '/bus-management/staff/employee',
    bus_charging_station: '/bus-management/charging-station',
    bus_charging_station_schedule: '/bus-management/charging-station/schedules',
    missing_tickets: '/bus-management/missing-tickets',
    report_transport_order_elec: '/bus-management/shipping-order/detail/inspection/report',
    getUrl: function (key, apiVersion = 'bus_management') {
        switch (apiVersion) {
            case 1:
                return `${this.API_V1}${this[key]}`;
            case 2:
                return `${this.API_V2}${this[key]}`;
            case 'storage':
                return `${this.API_STORAGE}${this[key]}`;
            case 'futa_user':
                return `${this.API_FUTA_USER}${this[key]}`;
            case 'admin':
                return `${this.API_ADMIN}${this[key]}`;
            case 'tracking':
                return `${this.API_TRACKING}${this[key]}`;
            case 'bus_management':
                return `${this.API_BUS_MANAGEMENT}${this[key]}`;
            case 'erp':
                return `${this.API_OFFICE}${this[key]}`;

            default:
                return 'no_url_found';
        }
    },
    getHeaders: (token, configType = false, additionalHeaders = {}) => {
        const config = {
            'x-access-token': token,
            'accept-language': 'vi-VN',
            ...additionalHeaders,
        };

        switch (configType) {
            case 'v3-api':
                return {
                    ...config,
                    token_type: 'user',
                };
            case 'v2-api':
                return {
                    ...config,
                    'id-provider': 'v3',
                };
            case 'hrm':
                return {
                    authorization: `Bearer ${token}`,
                    'accept-language': 'vi-VN',
                    ...additionalHeaders,
                };
            case 'none':
                return {};
            default:
                return config;
        }
    },
};
